import { normalizeSelectQuestionType } from "./selectOtherOption";

type SingleSelectQuestionLike = {
  questionType?: unknown;
  options?: Record<string, unknown> | null;
};

export type SingleSelectDisplayOption = "radio" | "buttons";

export const SINGLE_SELECT_DISPLAY_OPTION = "singleSelectDisplay";
export const SINGLE_SELECT_BUTTON_BACKGROUND_COLOR_OPTION =
  "singleSelectButtonBackgroundColor";
export const SINGLE_SELECT_BUTTON_TEXT_COLOR_OPTION =
  "singleSelectButtonTextColor";
export const SINGLE_SELECT_BUTTON_BORDER_COLOR_OPTION =
  "singleSelectButtonBorderColor";

export const SINGLE_SELECT_BUTTON_DEFAULT_BACKGROUND_COLOR = "#ffffff";
export const SINGLE_SELECT_BUTTON_DEFAULT_TEXT_COLOR = "#000000";
export const SINGLE_SELECT_BUTTON_DEFAULT_BORDER_COLOR = "#000000";

const HEX_REGEX = /^#([0-9a-fA-F]{3}){1,2}$/;

function readHex(value: unknown, fallback: string) {
  if (typeof value !== "string") return fallback;
  const trimmed = value.trim();
  return HEX_REGEX.test(trimmed) ? trimmed : fallback;
}

export function getSingleSelectDisplayOption(
  question: SingleSelectQuestionLike,
): SingleSelectDisplayOption {
  if (normalizeSelectQuestionType(question.questionType) !== "single-select") {
    return "radio";
  }

  const raw = question.options?.[SINGLE_SELECT_DISPLAY_OPTION];
  return raw === "buttons" ? "buttons" : "radio";
}

export function getSingleSelectButtonColors(
  question: SingleSelectQuestionLike,
) {
  const options = question.options || {};
  return {
    backgroundColor: readHex(
      options[SINGLE_SELECT_BUTTON_BACKGROUND_COLOR_OPTION],
      SINGLE_SELECT_BUTTON_DEFAULT_BACKGROUND_COLOR,
    ),
    textColor: readHex(
      options[SINGLE_SELECT_BUTTON_TEXT_COLOR_OPTION],
      SINGLE_SELECT_BUTTON_DEFAULT_TEXT_COLOR,
    ),
    borderColor: readHex(
      options[SINGLE_SELECT_BUTTON_BORDER_COLOR_OPTION],
      SINGLE_SELECT_BUTTON_DEFAULT_BORDER_COLOR,
    ),
  };
}

/** Whether the question explicitly sets any custom button color. When
 *  false, the renderer falls back to the survey's theme/brand styling. */
export function hasCustomSingleSelectButtonColors(
  question: SingleSelectQuestionLike,
): boolean {
  const options = question.options || {};
  return [
    SINGLE_SELECT_BUTTON_BACKGROUND_COLOR_OPTION,
    SINGLE_SELECT_BUTTON_TEXT_COLOR_OPTION,
    SINGLE_SELECT_BUTTON_BORDER_COLOR_OPTION,
  ].some((key) => {
    const value = options[key];
    return typeof value === "string" && HEX_REGEX.test(value.trim());
  });
}
